import { WEBSITE_AUTH_STORAGE_KEY } from "./api_helper";

const pickDetail = (item) => {
  if (!item) return "";
  if (typeof item === "string") return item;
  if (item.field && item.detail) return `${item.field}: ${item.detail}`;
  return item.detail || item.message || item.title || "";
};

export const getBackendErrorMessage = (error) => {
  const payload = error?.response?.data;

  if (!payload) {
    return error?.message || "Something went wrong";
  }

  const nestedErrors = payload?.error?.errors;
  if (Array.isArray(nestedErrors) && nestedErrors.length) {
    return nestedErrors.map(pickDetail).filter(Boolean).join("\n");
  }

  const rootErrors = payload?.errors;
  if (Array.isArray(rootErrors) && rootErrors.length) {
    return rootErrors.map(pickDetail).filter(Boolean).join("\n");
  }

  if (typeof payload?.error === "string") return payload.error;

  return (
    payload?.error?.detail ||
    payload?.error?.message ||
    payload?.error?.title ||
    payload?.message ||
    payload?.detail ||
    error?.message ||
    "Something went wrong"
  );
};

export const helperFunction = async (
  asyncFunction,
  setIsLoading,
  _successMessage,
  onError,
) => {
  setIsLoading(true);
  try {
    const result = await asyncFunction();
    return result;
  } catch (error) {
    console.error("An error occurred:", error);
    const errorMessage = getBackendErrorMessage(error);
    if (onError) onError(errorMessage, error);

    if (error?.response?.status === 401) {
      const token = localStorage?.getItem(WEBSITE_AUTH_STORAGE_KEY);
      localStorage?.removeItem(WEBSITE_AUTH_STORAGE_KEY);
      if (token) {
        window.location.reload();
      }
    }

    return;
  } finally {
    setIsLoading(false);
  }
};
